// src/pages/LoginPage.js
import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Alert, Spin } from 'antd'; // Import Ant Design components
import { UserOutlined, LockOutlined, ShopOutlined } from '@ant-design/icons'; // Import icons
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';


const { Title } = Typography;

const LoginPage = () => {
    // Consume the login function and loading state from the AuthProvider
    const { login, isLoadingAuth } = useAuth();
    const navigate = useNavigate();

    // State for form values (optional, Ant Design Form handles this internally, but can be useful)
    // const [username, setUsername] = useState(''); // Updated variable name
    // const [password, setPassword] = useState('');
    // const [organizationIdentifier, setOrganizationIdentifier] = useState('');

    // State for handling login errors
    const [loginError, setLoginError] = useState(null);
    const [isLoggingIn, setIsLoggingIn] = useState(false); // State to manage button loading spinner

    // Handler for form submission
    const onFinish = async (values) => {
        console.log('Login form submitted with values:', values);
        setLoginError(null); // Clear previous errors
        setIsLoggingIn(true); // Start loading spinner on button

        // The 'values' object from Ant Design Form will now have the keys
        // 'username', 'password', and 'organizationIdentifier', matching the Flask API expectation.
        const result = await login(values); // Call the login function from AuthProvider

        if (!result.success) {
            // If login failed, display the error message from the backend
            setLoginError(result.message || 'Login failed. Please try again.');
            console.error('Login failed:', result.message);
        } else {
            // Login was successful, AuthProvider updated state and localStorage.
            // AppContent will automatically redirect due to isAuthenticated changing.
            console.log('Login successful, redirecting...');
            // Policy: kiosk / customer roles always go directly to /Totem
            if (result.user?.role === 'kiosk' || result.user?.role === 'Customer') {
                navigate('/Totem', { replace: true });
            }
        }

        setIsLoggingIn(false); // Stop loading spinner
    };

    // Handler for form submission failure (e.g., validation errors)
    const onFinishFailed = (errorInfo) => {
        console.log('Login form submission failed:', errorInfo);
        setLoginError('Please fill in all required fields.');
    };

    // Render a loading spinner if the AuthProvider is still loading (e.g., initial localStorage check)
    // This is a fallback, AppContent should handle the primary isLoadingAuth check.
    if (isLoadingAuth) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Spin size="large" tip="Loading authentication state..." />
            </div>
        );
    }


    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: 'var(--color-background-light)' }}>
            <Card style={{ width: 400, textAlign: 'center', padding: '20px' }}>
                <Title level={2}>HORIZONTE PyME</Title>
                <Form
                    name="login"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    layout="vertical" // Use vertical layout for labels above inputs
                >
                    <Form.Item
                        label="Usuario"
                        name="username" // <--- CHANGED from "identifier" to "username"
                        rules={[{ required: true, message: 'Por favor ingrese usuario' }]}
                    >
                        <Input prefix={<UserOutlined />} placeholder="Usuario" />
                    </Form.Item>

                    <Form.Item
                        label="Contraseña"
                        name="password"
                        rules={[{ required: true, message: 'Por favor ingrese contraseña' }]}
                    >
                        <Input.Password prefix={<LockOutlined />} placeholder="Contraseña" />
                    </Form.Item>

                    <Form.Item
                        label="Cliente or CUIT"
                        name="organizationIdentifier"
                        rules={[{ required: true, message: 'Por favor ingrese su identificador de cliente' }]}
                    >
                        {/* Assuming organizationIdentifier is text input based on SP */}
                        <Input prefix={<ShopOutlined />} placeholder="Cliente or CUIT" />
                    </Form.Item>

                    {/* Display login error if any */}
                    {loginError && (
                        <Form.Item>
                            <Alert message={loginError} type="error" showIcon />
                        </Form.Item>
                    )}

                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={isLoggingIn} block>
                            Ingresar
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
};

export default LoginPage;